// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var ChartHotkeysEnum;
(function (ChartHotkeysEnum) {
    ChartHotkeysEnum["DisplayInFullScreenMode"] = "DisplayInFullScreenMode";
    ChartHotkeysEnum["ChangeChartStyle"] = "ChangeChartStyle";
    ChartHotkeysEnum["ZoomIn"] = "ZoomIn";
    ChartHotkeysEnum["ZoomOut"] = "ZoomOut";
    ChartHotkeysEnum["AutoManualScaling"] = "AutoManualScaling";
    ChartHotkeysEnum["MouseTrading"] = "MouseTrading";
    ChartHotkeysEnum["ShowHideInfoWindow"] = "ShowHideInfoWindow";
    ChartHotkeysEnum["AddIndicator"] = "AddIndicator";
    ChartHotkeysEnum["RemoveDrawings"] = "RemoveDrawings";
    ChartHotkeysEnum["ShowFilledOrders"] = "ShowFilledOrders";
    ChartHotkeysEnum["SetPeriod_Tick"] = "SetPeriod_Tick";
    ChartHotkeysEnum["SetPeriod_1m"] = "SetPeriod_1m";
    ChartHotkeysEnum["SetPeriod_5m"] = "SetPeriod_5m";
    ChartHotkeysEnum["SetPeriod_15m"] = "SetPeriod_15m";
    ChartHotkeysEnum["SetPeriod_30m"] = "SetPeriod_30m";
    ChartHotkeysEnum["SetPeriod_1H"] = "SetPeriod_1H";
    ChartHotkeysEnum["SetPeriod_4H"] = "SetPeriod_4H";
    ChartHotkeysEnum["SetPeriod_1D"] = "SetPeriod_1D";
    ChartHotkeysEnum["SetPeriod_1W"] = "SetPeriod_1W";
    ChartHotkeysEnum["SetPeriod_1M"] = "SetPeriod_1M";
    ChartHotkeysEnum["SetPeriod_1Y"] = "SetPeriod_1Y";
    ChartHotkeysEnum["ObjectManagerIndicators"] = "ObjectManagerIndicators";
    ChartHotkeysEnum["ObjectManagerDrawings"] = "ObjectManagerDrawings";
    ChartHotkeysEnum["ObjectManagerOverlays"] = "ObjectManagerOverlays";
    ChartHotkeysEnum["DrawLine"] = "DrawLine";
    ChartHotkeysEnum["DrawVerticalLine"] = "DrawVerticalLine";
    ChartHotkeysEnum["DrawHorizontalLine"] = "DrawHorizontalLine";
    ChartHotkeysEnum["DrawArrow"] = "DrawArrow";
    ChartHotkeysEnum["DrawComments"] = "DrawComments";
    ChartHotkeysEnum["DrawFibonacciRetracement"] = "DrawFibonacciRetracement";
    ChartHotkeysEnum["DrawFibonacciExpansion"] = "DrawFibonacciExpansion";
    ChartHotkeysEnum["DrawFibonacciArc"] = "DrawFibonacciArc";
    ChartHotkeysEnum["DrawFibonacciTimeGoalAnalysis"] = "DrawFibonacciTimeGoalAnalysis";
    ChartHotkeysEnum["DrawFibonacciFans"] = "DrawFibonacciFans";
    ChartHotkeysEnum["DrawFibonacciSpiral"] = "DrawFibonacciSpiral";
    ChartHotkeysEnum["DrawFibonacciTimeZone"] = "DrawFibonacciTimeZone";
    ChartHotkeysEnum["DrawFibonacciPhiChannel"] = "DrawFibonacciPhiChannel";
    ChartHotkeysEnum["DrawTriangle"] = "DrawTriangle";
    ChartHotkeysEnum["DrawPolygon"] = "DrawPolygon";
    ChartHotkeysEnum["DrawRectangle"] = "DrawRectangle";
    ChartHotkeysEnum["ShowHideGrid"] = "ShowHideGrid";
    ChartHotkeysEnum["ShowOpenPositions"] = "ShowOpenPositions";
    ChartHotkeysEnum["ShowVolume"] = "ShowVolume";
    ChartHotkeysEnum["ShowWorkingOrders"] = "ShowWorkingOrders";
    ChartHotkeysEnum["CancelLastOrderOnSelectedInstrument"] = "Chart.CancelLastOrderOnSelectedInstrument";
    ChartHotkeysEnum["CancelAllActiveOrdersOnSelectedInstrument"] = "Chart.CancelAllActiveOrdersOnSelectedInstrument";
    ChartHotkeysEnum["CancelBuyOrderClosestToTheLastPrice"] = "Chart.CancelBuyOrderClosestToTheLastPrice";
    ChartHotkeysEnum["CancelSellOrderClosestToTheLastPrice"] = "Chart.CancelSellOrderClosestToTheLastPrice";
})(ChartHotkeysEnum || (ChartHotkeysEnum = {}));
export var MarketDepthHotkeysEnum;
(function (MarketDepthHotkeysEnum) {
    MarketDepthHotkeysEnum["CancelLastOrderOnSelectedInstrument"] = "MarketDepth.CancelLastOrderOnSelectedInstrument";
    MarketDepthHotkeysEnum["CancelAllActiveOrdersOnSelectedInstrument"] = "MarketDepth.CancelAllActiveOrdersOnSelectedInstrument";
    MarketDepthHotkeysEnum["CancelBuyOrderClosestToTheLastPrice"] = "MarketDepth.CancelBuyOrderClosestToTheLastPrice";
    MarketDepthHotkeysEnum["CancelSellOrderClosestToTheLastPrice"] = "MarketDepth.CancelSellOrderClosestToTheLastPrice";
    MarketDepthHotkeysEnum["PlaceBuyOrder"] = "PlaceBuyOrder";
    MarketDepthHotkeysEnum["PlaceSellOrder"] = "PlaceSellOrder";
    MarketDepthHotkeysEnum["SellAsk"] = "SellAsk";
    MarketDepthHotkeysEnum["BuyBid"] = "BuyBid";
})(MarketDepthHotkeysEnum || (MarketDepthHotkeysEnum = {}));
export var OrderEntryHotkeysEnum;
(function (OrderEntryHotkeysEnum) {
    OrderEntryHotkeysEnum["OpenBuyOE"] = "OpenBuyOE";
    OrderEntryHotkeysEnum["OpenSellOE"] = "OpenSellOE";
    OrderEntryHotkeysEnum["PlaceOrder"] = "PlaceOrder";
})(OrderEntryHotkeysEnum || (OrderEntryHotkeysEnum = {}));
export var TradingHotkeysEnum;
(function (TradingHotkeysEnum) {
    TradingHotkeysEnum["CloseAllPositionsImmediately"] = "CloseAllPositionsImmediately";
    TradingHotkeysEnum["CancelAllOrdersImmediately"] = "CancelAllOrdersImmediately";
    TradingHotkeysEnum["CancelAllOrdersAndCloseAllPositionsImmediately"] = "CancelAllOrdersAndCloseAllPositionsImmediately";
    TradingHotkeysEnum["OpenReports"] = "OpenReports";
})(TradingHotkeysEnum || (TradingHotkeysEnum = {}));
export var WorkingOrdersHotkeysEnum;
(function (WorkingOrdersHotkeysEnum) {
    WorkingOrdersHotkeysEnum["ModifyOrder"] = "ModifyOrder";
    WorkingOrdersHotkeysEnum["CancelOrder"] = "CancelOrder";
    WorkingOrdersHotkeysEnum["ChangeToMarket"] = "ChangeToMarket";
})(WorkingOrdersHotkeysEnum || (WorkingOrdersHotkeysEnum = {}));
export var InformerPanelActionHotkeysEnum;
(function (InformerPanelActionHotkeysEnum) {
    InformerPanelActionHotkeysEnum["CopySelectedSymbols"] = "CopySelectedSymbols";
    InformerPanelActionHotkeysEnum["PasteSelectedSymbols"] = "PasteSelectedSymbols";
})(InformerPanelActionHotkeysEnum || (InformerPanelActionHotkeysEnum = {}));
export var OrderCancelActionHotkeysEnum;
(function (OrderCancelActionHotkeysEnum) {
    OrderCancelActionHotkeysEnum[OrderCancelActionHotkeysEnum["LastOrder"] = 0] = "LastOrder";
    OrderCancelActionHotkeysEnum[OrderCancelActionHotkeysEnum["AllOrders"] = 1] = "AllOrders";
    OrderCancelActionHotkeysEnum[OrderCancelActionHotkeysEnum["BuyOrder"] = 2] = "BuyOrder";
    OrderCancelActionHotkeysEnum[OrderCancelActionHotkeysEnum["SellOrder"] = 3] = "SellOrder";
})(OrderCancelActionHotkeysEnum || (OrderCancelActionHotkeysEnum = {}));
export const HotkeysKeyless = '<None>';
export const HotkeysGroupTrading = 'TRADING';
